<template>
  <div id="police">
    <div class="input">
      <b-form-radio-group
        buttons
        button-variant="outline-secondary"
        stacked
        v-model="inputType"
        v-on:change="onChangeInputType"
        size="lg"
        class="input-type"
      >
        <b-form-radio value="word">單字</b-form-radio>
        <b-form-radio value="sentence">文章</b-form-radio>
      </b-form-radio-group>
      <div class="input-text">
        <template v-if="inputTypeWord">
          <b-form-input
            v-model="input"
            v-on:update="handleWord"
            class="input-word"
            autofocus
            debounce="1000"
            size="lg"
            placeholder="輸入文字"
          ></b-form-input>
          <span>試試這些單字：</span>
          <b-button
            v-for="word in choosedSuggestWords"
            v-bind:key="word"
            v-on:click="onClickWord"
            variant="info"
            class="suggest-button"
          >{{word}}</b-button>
        </template>
        <template v-if="inputTypeSentence">
          <b-overlay
            :show="stateLoading"
            rounded="lg"
            opacity="0.6"
            key="overlay"
          >
            <b-input-group :aria-hidden="stateLoading ? 'true' : null">
              <b-form-textarea
                v-model="inputSentence"
                v-on:update="handleSentenceInput"
                :disabled="stateLoading"
                :state="inputSentence.length <= maxSentenceLength"
                class="input-sentence"
                :placeholder="`輸入文章(最多${maxSentenceLength}字)`"
                rows="5"
                max-rows="5"
                autofocus
              ></b-form-textarea>
              <b-button
                :disabled="stateLoading"
                v-on:click="handleSentence"
              >稽查</b-button>
            </b-input-group>
          </b-overlay>
        </template>
      </div>
    </div>
    <b-overlay
      class="output"
      v-bind:class="outputClass"
      :show="stateLoading && inputTypeWord"
      rounded="lg"
    >
      <transition name="fade">
        <b-img
          v-if="stateResult && !safe"
          class="police-img"
          alt="Police"
          v-bind:src="this.images(this.imageFileName, true)"
        ></b-img>
      </transition>
      <div class="output-text">
        <template v-if="inputTypeWord">
          <h1>{{word}}</h1>
          <template v-if="stateResult">
            <h3 v-if="notFound">找不到相關詞</h3>
            <template v-else-if="safe">
              <h3>你可以安心使用這個詞</h3>
              <details style="position:absolute; bottom:50px;">
                <summary style="color: red;">🚨我覺得這個詞是支語！</summary>
                目前沒有辦法辨認，如果你想進一步開發這個網站，請聯繫我： goohcl777@gmail.com
              </details>
            </template>
            <template v-else-if="!safe">
              <b-tabs
                pills
                vertical
                fill
                v-model="selectedTabIndex"
              >
                <Meaning
                  v-for="(meaning, index) in meanings"
                  v-bind:key="index"
                  v-bind:tabIndex="(meanings.length > 1)?index:0"
                  v-bind:selectedTabIndex="selectedTabIndex"
                  v-bind:tabClass="tabClass[index]"
                  v-bind:taiwan="meaning.taiwan"
                  v-bind:china="meaning.china"
                  v-bind:english="english"
                ></Meaning>
                <GoogleTrend
                  id="google-trend"
                  v-bind:keywords="trendWords"
                  geo="TW"
                  v-bind:tabClass="tabClass[meanings.length]"
                />
              </b-tabs>
              <a
                v-bind:href="dataurl"
                v-if="dataurl.length > 0"
                target="_blank"
                rel="noopener noreferrer"
              >資料來源</a>
            </template>
          </template>
        </template>
        <template v-else-if="inputTypeSentence">
          <SentenceMeaning
            :sentence="sentence"
            :meanings="meaningSentence"
          ></SentenceMeaning>
        </template>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import Meaning from "@/components/Meaning.vue";
import SentenceMeaning from "@/components/SentenceMeaning.vue";
import GoogleTrend from "@/components/GoogleTrend.vue";
import _ from "lodash";

// 萌典有「陸⃝」用法，但在台灣是一般用語的詞：一律不視為支語
const notChinaTerms = ["這個", "品質", "工作"];

export default {
  name: "Police",
  components: {
    Meaning,
    SentenceMeaning,
    GoogleTrend
  },
  mounted: function() {
    this.images = require.context("@/assets/", true);
    // moedict only accepts traditional chinese; the dictionary is ~1MB, so load it as a separate chunk
    // cn -> tw converts character by character (视频 -> 視頻), keeping china-only terms detectable
    this.toTraditional = import(
      /* webpackChunkName: "opencc" */ "opencc-js/dist/umd/cn2t.js"
    )
      .then(OpenCC => OpenCC.Converter({ from: "cn", to: "tw" }))
      .catch(err => {
        console.log("載入簡轉繁失敗:", err);
        return text => text;
      });
  },
  data: function() {
    return {
      selectedTabIndex: 0,
      input: "",
      word: "", //input converted to traditional
      sentence: "", //inputSentence converted to traditional
      inputSentence:
        "屌絲才用小米？土豪用實力打臉「高端人士」！你窮跟品牌無關\n在手機行業面臨大洗牌的陰影下，各大玩家都圍繞著產品、品牌、渠道展開激烈的較量，就拿小米來說雖然底子並不薄弱，但一直不給力的產能和馬馬虎虎的品質問題始終在消磨用戶的信心。 在正式演講前的預熱中，雷軍提到如果實現三個願望就考慮退休。其中之一就是，“我希望未來不會再有人說雷總是勞模了，因為這個舞臺屬於小米的年輕人。”雷軍說。",
      inputType: "word",
      english: [],
      safe: false,
      notFound: false,
      //states: init, loading, result
      state: "init",
      suggestWords: [
        "視頻",
        "質量",
        "土豆",
        "內存",
        "靠譜",
        "鼠標",
        //"教程",
        "激光",
        //"刷屏",//not exist
        "硅膠",
        // "硬盤",
        "屏幕",
        //"接地氣",//not exist
        "富二代",
        "高端",
        "芯片",
        "激活",
        "信息",
        "攝像",
        //"服務器",
        "互聯網",
        "酸奶",
        "給力",
        "朋克"
        // 默認
      ],
      dataurl: "",
      meanings: [],
      imageIndex: 0,
      meaningSentence: [],
      imageCount: 45,
      trendkeyword: [],
      maxSentenceLength: 500
    };
  },
  computed: {
    tabClass: function() {
      var arr = Array(this.meanings.length + 1);
      for (var i = 0; i < arr.length; i++) {
        if (i == this.selectedTabIndex) {
          arr[i] = ["bg-primary", "text-light"];
        } else {
          arr[i] = ["bg-light", "text-info"];
        }
      }
      return arr;
    },
    choosedSuggestWords: function() {
      return _.sampleSize(this.suggestWords, 10);
    },
    outputClass: function() {
      switch (this.state) {
        case "init":
          return "output-init";
        case "loading":
          return "output-loading";
        case "result":
          return this.notFound
            ? "output-init"
            : this.safe
            ? "output-safe"
            : "output-unsafe";
        default:
          return "";
      }
    },
    trendWords: function() {
      return this.equivalentTaiwanWord.concat([this.chinaWord]);
    },
    chinaWord: function() {
      return this.word;
    },
    equivalentTaiwanWord: function() {
      let taiwanMeaning =
        this.meanings.length > 0 ? this.meanings[0].taiwan : "";
      let equivalentTaiwanWords = [];
      if (taiwanMeaning) {
        equivalentTaiwanWords = taiwanMeaning.matchAll(/「([^、]+)」/g);
      }

      if (equivalentTaiwanWords) {
        equivalentTaiwanWords = Array.from(equivalentTaiwanWords).map(function(
          match
        ) {
          return match[1];
        });
      }
      return equivalentTaiwanWords && equivalentTaiwanWords.length > 0
        ? equivalentTaiwanWords
        : [];
    },
    imageFileName: function() {
      return "./" + this.imageIndex.toString().padStart(2, "0") + ".png";
    },
    stateLoading: function() {
      return this.state === "loading";
    },
    stateResult: function() {
      return this.state === "result";
    },
    inputTypeWord: function() {
      return this.inputType === "word";
    },
    inputTypeSentence: function() {
      return this.inputType === "sentence";
    }
  },
  methods: {
    strip: function(input) {
      return input.replace(/~|`/gi, "");
    },
    clean: function(input) {
      return input.replace(/臺⃝|陸⃝|~|`/gi, "");
    },
    onClickWord: function(e) {
      this.selectedTabIndex = 0;
      this.input = e.target.textContent;
      this.handleWord();
    },
    resetWordData: function() {
      this.safe = true;
      this.notFound = false;
      this.taiwan = "";
      this.china = "";
      this.english = [];
      this.meanings = [];
      this.randomSetImage();
    },
    handleWord: async function() {
      this.state = this.input.length > 0 ? "loading" : "init";
      this.resetWordData();
      const toTraditional = await this.toTraditional;
      this.word = toTraditional(this.input);
      this.fetchDict(this.word, this.parseDict_word, this.parseDictError_word);
    },
    onChangeInputType: function() {
      this.state = "init";
    },
    resetSentenceData: function() {
      this.safe = true;
      this.notFound = false;
      this.meaningSentence = [];
      this.randomSetImage();
    },
    handleSentenceInput: function() {
      this.state = "init"; //reset state
      this.resetSentenceData();
    },
    loadSegmenter: function() {
      // jieba-wasm (~2.8MB gzip) is only loaded when sentence mode is used.
      // Loaded from CDN at runtime because webpack 4 cannot parse its import.meta.
      if (!this.segmenter) {
        const jiebaURL =
          "https://cdn.jsdelivr.net/npm/jieba-wasm@2.4.0/pkg/web/jieba_rs_wasm.js";
        const jieba = import(/* webpackIgnore: true */ jiebaURL).then(
          async module => {
            await module.default();
            return module;
          }
        );
        const toSimplified = import(
          /* webpackChunkName: "opencc-t2cn" */ "opencc-js/dist/umd/t2cn.js"
        ).then(OpenCC => OpenCC.Converter({ from: "tw", to: "cn" }));
        this.segmenter = Promise.all([jieba, toSimplified]).then(
          ([jieba, toSimplified]) => sentence => {
            // jieba's dictionary is simplified chinese: segment the simplified text,
            // then map the pieces back to the original (conversion is char-by-char)
            const simplified = toSimplified(sentence);
            if (simplified.length !== sentence.length) {
              return jieba.cut(sentence, true);
            }
            let i = 0;
            return jieba.cut(simplified, true).map(piece => {
              const word = sentence.slice(i, i + piece.length);
              i += piece.length;
              return word;
            });
          }
        );
        this.segmenter.catch(() => (this.segmenter = null)); //retry next time
      }
      return this.segmenter;
    },
    handleSentence: async function() {
      if (this.inputSentence.length > this.maxSentenceLength) {
        return; //TODO: show error tooltip using form control
      }
      this.state = "loading";
      this.resetSentenceData();
      try {
        const [toTraditional, segment] = await Promise.all([
          this.toTraditional,
          this.loadSegmenter()
        ]);
        this.sentence = toTraditional(this.inputSentence);
        // single characters are rarely 支語 and would flood moedict with requests
        const words = _.uniq(
          segment(this.sentence).filter(word => /^\p{Script=Han}{2,}$/u.test(word))
        );
        await Promise.all(
          words.map(word =>
            this.fetchDict(
              word,
              this.parseDict_sentence,
              this.parseDictError_sentence
            )
          )
        );
      } catch (err) {
        console.log("分詞失敗:", err);
      }
      this.state = "result";
    },
    fetchDict: function(word, callback, callbackError) {
      if (!word) {
        return;
      }
      //word must be traditional (see toTraditional)
      const jsonurl = `https://www.moedict.tw/c/${word}.json`;
      this.dataurl = `https://www.moedict.tw/~${word}`;

      return this.fetchJson(jsonurl, callback, callbackError);
    },
    async fetchJson(jsonurl, callback, callbackError) {
      try {
        const response = await fetch(jsonurl);
        callback(await response.json());
      } catch (err) {
        callbackError(err);
      }
    },
    getRandomInt: function(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min; //不含最大值，含最小值
    },
    randomSetImage: function() {
      this.imageIndex = this.getRandomInt(0, this.imageCount);
    },
    parseDict_word(jsonData) {
      //XXX: can vue use class without dom elements? we can put word in specific class
      let dictData = this.parseDict(jsonData);

      this.english = dictData.english.join(", ");
      this.meanings = dictData.meanings;
      this.safe = dictData.safe;
      this.state = "result";
    },
    parseDictError_word: function(err) {
      console.log("錯誤:", err);
      this.notFound = true;
      this.state = "result";
    },
    parseDict_sentence: function(jsonData) {
      //If use object, data cannot be updated by vue, so currently use array.push
      const meaning = this.parseDict(jsonData);
      if (meaning.chinaUsage) {
        this.safe = false;
      }
      this.meaningSentence.push(meaning);
    },
    parseDictError_sentence: function(err) {
      console.log(err);
    },
    parseDict: function(jsonData) {
      let label = jsonData["h"][0]["S"];
      let contents = jsonData["h"][0]["d"].map(c => this.strip(c["f"]));

      let english = "";
      try {
        english = jsonData["translation"]["English"];
        english = english.filter(str => !str.match(/[\u{0080}-\u{FFFF}]/gu)); //remove words including non-english
      } catch (e) {
        //pass
      }

      const taiwanLabel = "臺⃝";
      const chinaLabel = "陸⃝";
      const chinaOnlyLabel = "陸⃟";
      const taiwanOnlyLabel = "臺⃟";
      let newContents = [];
      let meanings = [];
      contents.forEach(function(content) {
        let meaning = {};
        if (content.includes(taiwanLabel)) {
          while (content.includes(taiwanLabel)) {
            let chinaIndex = content.indexOf(
              chinaLabel,
              content.indexOf(taiwanLabel)
            );
            if (chinaIndex == -1) {
              chinaIndex = content.length;
            }
            let taiwanMeaning = content.substring(
              content.indexOf(taiwanLabel),
              chinaIndex
            );

            content = content.replace(taiwanMeaning, "");
            meaning.taiwan = this.clean(taiwanMeaning);
          }
        }
        if (content.includes(chinaLabel)) {
          while (content.includes(chinaLabel)) {
            let taiwanIndex = content.indexOf(
              taiwanLabel,
              content.indexOf(taiwanLabel)
            );
            if (taiwanIndex == -1) {
              taiwanIndex = content.length;
            }
            let chinaMeaning = content.substring(
              content.indexOf(taiwanLabel),
              taiwanIndex
            );

            content = content.replace(chinaMeaning, "");
            meaning.china = this.clean(chinaMeaning);
          }
        }
        if (Object.keys(meaning).length > 0) {
          meanings.push(meaning);
        }
        newContents.push(content); //without meanings with label
      }, this);

      if (label === chinaOnlyLabel) {
        let chinaMeaning = this.clean(newContents.join(""));
        if (meanings.length > 0) {
          meanings[0].china = chinaMeaning;
        } else {
          meanings.push({ china: chinaMeaning });
        }
      } else if (label == taiwanOnlyLabel) {
        meanings = [];
      }

      const word = this.strip(jsonData["t"]);
      if (notChinaTerms.includes(word)) {
        meanings = [];
      }

      // China usage shown in sentence mode:
      //   the whole word is china-only (陸⃟), e.g. 鼠標
      //   or a definition is china-only, preferring one with a taiwan equivalent,
      //   e.g. 渠道: 陸⃝比喻門路；途徑。臺⃝即「管道」。 / 土豪: 陸⃝指極其富有又喜歡炫耀財富的人。
      // Not notes inside a definition, e.g. 品質: 物品或工作等優劣程度。陸⃝也作「質量」。
      const toUsage = definitions => {
        const text = definitions.join("");
        const taiwanIndex = text.indexOf(taiwanLabel);
        return {
          china: this.clean(
            taiwanIndex == -1 ? text : text.substring(0, taiwanIndex)
          ).replace(/∥$/, ""),
          taiwan: taiwanIndex == -1 ? "" : this.clean(text.substring(taiwanIndex))
        };
      };
      let chinaUsage = null;
      if (notChinaTerms.includes(word)) {
        //pass
      } else if (label === chinaOnlyLabel) {
        chinaUsage = toUsage(contents);
      } else {
        const chinaDefinitions = contents.filter(c => c.startsWith(chinaLabel));
        const usage =
          chinaDefinitions.find(c => c.includes(taiwanLabel + "即")) ||
          chinaDefinitions[0];
        if (usage) {
          chinaUsage = toUsage([usage]);
        }
      }

      return {
        word: word,
        meanings: meanings,
        safe: meanings.length == 0,
        chinaUsage: chinaUsage,
        english: english
      };
    }
  }
};
</script>

<style scoped>
@import "../font.css";

#police {
  grid-area: c;
  display: grid;
  grid-template-areas:
    "in"
    "out";
  grid-template-rows: 170px 1fr;
  grid-template-columns: 1fr;
}

.input {
  grid-area: in;
  background-color: #efb700;
  display: grid;
  padding: 20px;
  grid-template-areas: "type text text";
  grid-template-rows: 1fr;
  grid-template-columns: 80px 1fr 1fr;
}
.input-type {
  grid-area: type;
  display: block; /* weird bug of bootstrap radio button */
  height: 60%;
  margin: 3px;
}
.input-text {
  grid-area: text;
  margin: 5px;
}
.input-word {
  font-size: 22px;
  height: 40px;
  width: 30%;
  margin: 20px auto;
}
.suggest-button {
  margin: 2.5px;
}
.input-sentence {
}
.input-sentence-button {
  margin: 10px;
}
.output {
  grid-area: out;
  background-color: #efb700;
  text-align: left;
  padding: 20px;
  display: grid;
  grid-template-areas: "text img";
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 300px;
  grid-gap: 10px;
}
.output-text {
  grid-area: text;
}
.output-safe {
  background-color: #008450 !important;
  color: #ffffff;
}
.output-unsafe {
  background-color: #b81d13 !important;
  color: #c8f7c5;
}
.output-init {
  /* default color */
}
.output-loading {
  /* default color */
}
.police-img {
  grid-area: img;
  display: block;
  width: 100%;
}

@media (max-width: 768px) {
  #police {
    grid-template-rows: auto 1fr;
  }
  .input {
    padding: 10px;
    grid-template-areas:
      "type"
      "text";
    grid-template-columns: 1fr;
  }
  .input-type {
    height: auto;
  }
  .input-word {
    width: 100%;
    margin: 10px auto;
  }
  .output {
    padding: 10px;
    grid-template-areas:
      "img"
      "text";
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
  .police-img {
    max-width: 200px;
    margin: 0 auto;
  }
  .output-text h1 {
    word-break: break-all;
  }
  /* vertical tabs -> horizontal tabs stacked above content */
  .output-text ::v-deep .tabs > .col-auto,
  .output-text ::v-deep .tabs > .tab-content {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .output-text ::v-deep .tabs .nav.flex-column {
    flex-direction: row !important;
    margin-bottom: 10px;
  }
  .output-text ::v-deep details {
    position: static !important;
    margin-top: 20px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
